const childRoutes = prop => [
    {
        path: 'assign-user',
        name: prop + '.assign_user',
        meta: { auth: true },
        component: () => import('../pages/assign-user/List.vue')
    }
]
const routes = [
    {
        path: '/hospital-disability-service/thirty-percent/configuration',
        name: 'hospital_disability_service.thirty_percent.configuration',
        component: () => import('@/layouts/HospitalDisabilityService.vue'),
        meta: { auth: true },
        children: childRoutes('hospital_disability_service.thirty_percent.configuration')
    }
]

export default routes
